import React, { Component } from 'react';
import instagram from '../../../assets/ig-color-icon.png';
import Alert from '../../generalComponents/Alert';

import PropTypes from 'prop-types';

class Instagram extends Component {
    constructor(props) {
        super(props);

        this.state = {
            instaUsername: '',
            password: '',
            twoFa: '',
            status: '',
            showAlert: false,
            alertType: '',
            alertMessage: '',
            loading: false
        };
        
        this.token = this.props.token;
    }

    componentDidMount = () => {
        const { username } = this.props.user.user;
        this.getInstaStatus(username, this.token);
    };

    getInstaStatus(user, token) {
        this.props.api.instagram.getUser({
            user,
            token,
        })
            .then(response => {
                this.setState({ status: response.status, loading: false });
            })
            .catch(err => {
                console.error(err);
                this.setState({ status: 'error', loading: false });
            });
    }

    onErrorClick = () => {
      const { username } = this.props.user.user;

      this.getInstaStatus(username, this.token)
    };

    handleChange = e => {
        const { name, value } = e.target;

        this.setState({
            [name]: value
        });
    };

    connectInstagram = () => {
        const { instaUsername, password } = this.state;
        const { username } = this.props.user.user;
    
        this.props.api.instagram.postUser({
            user: username,
            token: this.token,
            username: instaUsername,
            password
        })
            .then(async response => {
                if (response.status === 403) {
                    this.showAlert('error', 'The password and/or username you entered is incorect. Please try again.')
                } else if (response.status === 417) {
                    const json = await response.json();
                    this.setState({
                        nonceCode: json.nonceCode,
                        userId: json.userId
                    })
                }
                this.getInstaStatus(username, this.token);
            })
            .catch(err => {
                console.error(err);
                this.setState({ status: 'error', loading: false });
            });
    };

    disconnectInstagram = () => {
        const { username } = this.props.user.user;
    
        this.props.api.instagram.deleteUser({
            user: username,
            token: this.token
        })
            .then(() => {
                this.getInstaStatus(username, this.token);
            })
            .catch(err => {
                console.error(err);
                this.setState({ status: 'error', loading: false });
            });
    };

    twoFactorAuth = () => {
        const { twoFa, nonceCode, userId, password, instaUsername } = this.state;
        const { username } = this.props.user.user;
        
        if (!nonceCode) {
            this.props.api.instagram.postTwofa({
                user: username,
                token: this.token,
                code: twoFa
            })
                .then(response => {
                    if (response.status > 299) {
                        this.showAlert('error', 'Wrong code. Please re-login');
                        this.setState({
                            loading: false,
                            twoFa: '',
                            nonceCode: undefined,
                            userId: undefined
                        }, () => {
                            this.getInstaStatus(username, this.token);
                        });
                    } else if (response.status < 300) {
                        this.setState({
                            loading: false,
                            twoFa: '',
                            nonceCode: undefined,
                            userId: undefined,
                            status: response.status
                        });
                    }
                })
                .catch(err => {
                    console.error(err);
                    this.setState({ status: 'error', loading: false });
                });
        } else {
            this.props.api.instagram.postCode({
                user: username,
                token: this.token,
                code: twoFa,
                nonceCode,
                userId
            })
                .then(response => {
                    if (response.status > 299 && response.status !== 401) {
                        this.showAlert('error', 'Wrong code. Please re-login')
                    }
            
                    if (response.status === 401) {
                        this.setState({
                            status: response.status,
                            loading: false,
                            twoFa: '',
                            nonceCode: undefined,
                            userId: undefined
                        });
                    } else {
                        this.getInstaStatus(username, this.token);
                    }
                    // this.getInstaStatus(username, this.token);
                })
                .catch(err => {
                    console.error(err);
                    this.setState({ status: 'error', loading: false });
                });
        }
    };

    showAlert = (alertType, alertMessage) => {
       this.setState({
         showAlert: true,
         alertType,
         alertMessage

       })
    };

    hideAlert = () => {
       this.setState({
          showAlert: false,
          alertMessage: '',
          alertType: ''
       })
    };

    renderPod = () => {
        const { status, twoFa, instaUsername, password } = this.state;
        
        if (status === 'error') {
            return (
                <div>
                    <p>An error was encountered</p>
                    <button
                        className="btn btn-black"
                        onClick={this.onErrorClick}
                    >
                        Retry
                    </button>
                </div>
            );
        } else if (status === 401 || status === 417) {
            return (
                <div>
                    <p>
                        { status === 417 &&
                        'Please input the email or SMS code that you have received from Instagram/Facebook.'
                        }
                        { status === 401 &&
                        'Please input the SMS code that you have received from Instagram/Facebook.'
                        }
                        
                    </p>
                    <div className="sec" style={{ marginBottom: '20px' }}>
                        <input
                            className="form-input"
                            name="twoFa"
                            type="text"
                            onChange={this.handleChange}
                            value={twoFa}
                            disabled={this.state.loading}
                        />
                    </div>
                    <button
                        className="btn btn-black"
                        style={{ marginRight: '20px' }}
                        onClick={() => {
                            this.setState({
                                loading: true
                            }, () => {
                                this.twoFactorAuth();
                            });
                        }}
                        disabled={this.state.loading}
                    >
                        Authenticate
                    </button>
                    <button
                        className="btn btn-black"
                        disabled={this.state.loading}
                        onClick={() => {
                            this.disconnectInstagram();
                            this.setState({ status: 'noStatus' });
                        }}
                    >
                        Cancel
                    </button>
                </div>
            );
        } else if (status > 299) {
            return (
                <div className="form">
                    <p className="p-info">
                        Broadcast simultaneously on Instagram, when you go
                        live on Naked News. Please enter your Instagram
                        credentials below to get started.
                        <br/>
                        <br/>
                        Important:
                        <br/>
                        We only support accounts that have verified phone numbers and email addresses.<br/><br/>
                        Logged in via facebook? Please try using your facebook credentials.
                        If this does not work please retrieve your password via "Forgot password" on <a href={"https://instagram.com"}>Instagram</a>.
                    </p>
            
                    <div className="sec">
                        <input
                            name="instaUsername"
                            className="form-input"
                            placeholder="Username"
                            value={instaUsername}
                            onChange={this.handleChange}
                            disabled={this.state.loading}
                        />
                    </div>
                    <div className="sec">
                        <input
                            name="password"
                            type="password"
                            className="form-input"
                            placeholder="Password"
                            value={password}
                            onChange={this.handleChange}
                            disabled={this.state.loading}
                        />
                    </div>
                    <div className="sec">
                        <button
                            className="btn btn-black"
                            disabled={this.state.loading}
                            onClick={() => {
                                this.setState({
                                    loading: true
                                }, () => {
                                    this.connectInstagram();
                                });
                            }}
                        >
                            Connect
                        </button>
                    </div>
                </div>
            );
        } else if (status > 199 && status < 300) {
            return (
                <div>
                    <p>You are connected to Instagram.</p>
                    <button
                        className="btn btn-black"
                        onClick={this.disconnectInstagram}
                    >
                        Disconnect
                    </button>
                </div>
            );
        }
    };

    render() {
       const { showAlert, alertType, alertMessage } = this.state;
        return (
            <div className="pod social">
                {showAlert && (
                    <Alert onClose={this.hideAlert} type={alertType}>
                        {alertMessage}
                    </Alert>
                )}
                <div className="icon">
                    <img src={instagram} alt="" />
                </div>
                <div className="pod-content">
                    <div className="title">Instagram</div>
                    {this.renderPod()}
                </div>
            </div>
        );
    }
}

Instagram.propTypes = {
    api: PropTypes.object.isRequired,
    token: PropTypes.string.isRequired,
    user: PropTypes.object.isRequired
};

export default Instagram;
